import {HttpClient} from "../../service/httpClient/HttpClient";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import moment from "jalali-moment";
import axios from "axios";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

export class ElectionService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getElectionList(fundID, page, size = 20) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/elections`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page: page,
                    size: size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewElection(fundID, groupId, electionData, clearFields) {
        this.loading(setLoadingStateDispatch(true))
        this.httpClient.post(
            `fund-presentation/funds/${fundID}/groups/${groupId}/elections`,
            electionData,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {
            clearFields()
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "انتخابات جدید با موفقیت افزوده شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason,"خطا در دریافت لیست انتخابات",this.snackbar,this.loading)

        })
    }

    updateElection(fundID, groupId, itemId, electionData) {
        this.loading(setLoadingStateDispatch(true))
        this.httpClient.put(
            `fund-presentation/funds/${fundID}/groups/${groupId}/elections/${itemId}`,
            this.httpClient.prepareUserAccessHeader(this.token),
            electionData
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی انتخابات با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason,"خطا در بروزرسانی انتخابات!",this.snackbar,this.loading)
        })

    }

    getElectionInfo(fundID, electionId) {
        const electionInfo = this.httpClient.get(
            `fund-presentation/funds/${fundID}/elections/${electionId}`,
            this.httpClient.prepareUserAccessHeader(this.token),
        )

        const electionResult = this.httpClient.get(
            `fund-presentation/funds/${fundID}/elections/${electionId}/results`,
            this.httpClient.prepareUserAccessHeader(this.token)
        )

        const electionRequests = [electionInfo, electionResult]

        return new Promise((resolve, reject) => {
            axios.all(electionRequests).then(
                axios.spread((electionInfo, electionResult) => {
                    resolve({
                        electionInfo,
                        electionResult
                    })
                })
            ).catch(reject)
        })
    }

    prepareElectionData(title, startDate, startTime, endDate, endTime, published, enabled, candidatesList, description) {
        const candidates = []
        candidatesList.map(item => {
            candidates.push({
                "title": item.label
            })

        })
        return {
            "title": title,
            "description": description,
            "startPersianTime": startTime + ":00",
            "endPersianTime": endTime + ":00",
            "startPersianDate": startDate.replaceAll("/", "-"),
            "endPersianDate": endDate.replaceAll("/", "-"),
            "enabled": enabled,
            "published": published,
            "candidates": candidates
        }
    }

    prepareUpdateElectionData(title, startDate, endDate, published, enabled, candidatesList, description) {
        const candidates = []
        candidatesList.map(item => {
            candidates.push({
                "title": item.label
            })

        })
        return {
            "title": title,
            "description": description,
            "startTime": moment.from(startDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') + "T00:00",
            "endTime": moment.from(endDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') + "T23:59",
            "candidates": candidates
        }
    }

    disableElection(fundID, electionId, refreshData) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.delete(
            `fund-presentation/funds/${fundID}/elections/${electionId}`,
            this.httpClient.prepareUserAccessHeader(this.token),
        ).then(response => {

            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "لغو انتخابات با موفقیت انجام شد!"))
            refreshData()
        }).catch(reason => {
            ServerErrorHandler(reason,"خطا در لغو انتخابات!",this.snackbar,this.loading)
        })
    }

    publishElection(fundID, electionId, refreshData) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            `fund-presentation/funds/${fundID}/elections/${electionId}/published`,
            this.httpClient.prepareUserAccessHeader(this.token),
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "انتشار انتخابات با موفقیت انجام شد."))
            refreshData()
        }).catch(reason => {
            ServerErrorHandler(reason,"خطا در انتشار انتخابات!",this.snackbar,this.loading)
        })
    }

    endElection(fundID, electionId, getElectionData) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            `fund-presentation/funds/${fundID}/elections/${electionId}/force-finish`,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {
            getElectionData()
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "انتخابات با موفقیت پایان یافت."))
        }).catch(reason => {
            ServerErrorHandler(reason,"خطا در در پایان دادن به انتخابات!",this.snackbar,this.loading)
        })
    }

    extensionElection(fundID, electionId, endDate, endTime) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            `fund-presentation/funds/${fundID}/elections/${electionId}/extension`,
            this.httpClient.prepareUserAccessHeader(this.token),
            {
                newEndPersianTime: endTime + ":00",
                newEndPersianDate: endDate
            }
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تمدید انتخابات با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason,"خطا در تمدید انتخابات",this.snackbar,this.loading)
        })
    }

    getElectionResult(fundID, electionId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/elections/${electionId}/results`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    getElectionVotes(fundID, electionId, candidateId, page) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/elections/${electionId}/candidates/${candidateId}/votes`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page,
                    size: 20
                }
            ).then(resolve).catch(reject)
        })
    }
}